export default {
  titleText: {
    color: data => data.color,
  },
};



// WEBPACK FOOTER //
// ./default-modules/ui/title/title.theme.ts